import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    regulator_Name: [],
  },
  submitted: 0,
};

const OfftakefilterSlice = createSlice({
  name: "offtakefilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const {
  addFilters,
  applyFilters,
  chgSubmitted,
  // chgFmsNav,
  resetFilters,
} = OfftakefilterSlice.actions;

export default OfftakefilterSlice.reducer;
